/**
 * Whether the people list should follow AI search rows (including zero matches)
 * instead of browse filters.
 *
 * When filtering by team position skills, the list must be driven by that filter
 * (lexical match on profiles), not stale `aiMatches` from an unrelated chat search.
 */
export function shouldDriveListFromAiSearch(
  isAIMode: boolean,
  aiSearchCriteria: unknown | null | undefined,
  filterByPositionId: number | null = null
): boolean {
  if (filterByPositionId != null) return false;
  return isAIMode && aiSearchCriteria != null;
}
